import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
const Services = () => {
  return (
    <section id='services'>
      <h5>What I am currently learning</h5>
      <h2>Research Interests</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>ML for Electronic Design Automation</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Machine Learning and Deep Learning</p>
            </li>


            <li>
              <BiCheck className='service__list-icon' />
              <p>Graph Neural Networks</p>
            </li>

            <li>
              <BiCheck className='service__list-icon' />
              <p>Reinforcement Learning</p>
            </li>

            <li>
              <BiCheck className='service__list-icon' />
              <p>Reverse Engineering in EDA</p>
            </li>


          </ul>
        </article>

        {/* END OF WEB DEV */}

        <article className="service">
          <div className="service__head">
            <h3>Human Computer Interaction</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Affective Video Conferencing</p>
            </li>

            <li>
              <BiCheck className='service__list-icon' />
              <p>Affective Gaming</p>
            </li>

            <li>
              <BiCheck className='service__list-icon' />
              <p>Computer Vision, Image Processing</p>
            </li>

          </ul>
        </article>

         <article className="service">
          <div className="service__head">
            <h3>Natural Language Processing</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Low Resource Language Data collection: IyunAI</p>
            </li>

            <li>
              <BiCheck className='service__list-icon' />
              <p>Machine Translation, Hate Speech Classification</p>
            </li>

            <li>
              <BiCheck className='service__list-icon' />
              <p>RNNs, LSTMs, Attention Mechanisms</p>
            </li>

            {/* <li>
              <BiCheck className='service__list-icon' />
              <p>Computer Vision, Image Processing</p>
            </li> */}

          </ul>
        </article>

        {/* END OF CONTENT CREATION */}
      </div>
    </section>
  )
}

export default Services